export class ValidateTwoFactorAuthenticationModel {
  Email: string;
  Password: string;
  Code: string;
}
